;
app.validationsMap = {
    /**
     * !!! all properties are optional !!!
     * EXAMPLE:
     *
     *  < fieldName > : {
     *      renderMutator        : function (fldObj) { [do_SOMETHING();] return fldObj;},
     *      postRender           : function ($elm)   { [do_SOMETHING();] return; },
     *      normalizeSubmittedVal: function (value)  { [do_SOMETHING();] return value;},
     *      checks: {
     *          notEmpty: {
     *              msgKey: 'required_field'
     *          },
     *          maxlength: {
     *              max: 8,
     *              msgKey: 'maxlength'
     *          },
     *          ...
     *      }
     *  }
     *
     *  fldObj.inputType = 'text' | 'select' | 'tel' |'password' |  'number' | 'email' | 'composite_phone' | 'checkbox' |...
     *  fldObj.inputMode = 'decimal' | ...
     *  fldObj.maxlength = < int >
     *  fldObj.placeholder = < string >
     *  fldObj.selectInvisible = < boolean >
     *  fldObj.dropDownOptions = < Array >
     *  fldObj.extraClassName = < string >
     *  fldObj.rowExtraClassName = < string >
     *  fldObj.withSearch = < boolean >
     */
    blocked_method: {
        checks: {
            alwaysFalse: {
                msgKey: 'always_false'
            }
        }
    },
    ach_bank_account: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            maxlength: {
                max: 17,
                msgKey: 'maxlength'
            }
        }
    },
    ach_routing_number: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            maxlength: {
                max: 9,
                msgKey: 'maxlength'
            }
        }
    },
    amount: {
        maxlength: 9,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            noCommaSeparatedReg: {
                msgKey: 'invalid_entered_amount'
            },
            maxFractionLength : {
                msgKey : 'max_fraction_length'
            },
            inRange: {
                min: 0,
                max: 0,
                minMsgKey: 'amount_not_in_range_under_min',
                maxMsgKey: 'amount_not_in_range_above_max',
                msgKey: 'amount_not_in_range',
                currency: "",
                useCurrentState: false
            }
        }
    },
    btn_register_nuvei_card_user: {
        renderMutator: function (fldObj) {
            fldObj.value = app.locale.nuvei_order_free_card;

            return fldObj;
        },
        postRender: function ($elm) {
            $elm.on('click', app.util.showRegisterNuveiCardScreen);
        },
    },
    nuveiCardPassword: {
        checks: {
            maxlength: {
                max: 50,
                msgKey: 'maxlength'
            },
            minlength: {
                min: 8,
                msgKey: 'minlength'
            },
            testRegex: {
                regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, // at least one Uppercase, Lowercase and Number, at least 8 characthers
                msgKey: 'nvi_reg_password_validation_text'
            }
        }
    },
    aircash_phone: {
        renderMutator : function (fldObj) {
            if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                fldObj.value = fldObj.value.replace(/-/g, '');
            } else {
                fldObj.phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes, 'apmgw_Aircash');
                fldObj.inputType = 'composite_phone';

                if (fldObj.value && fldObj.value.indexOf('-') > -1) {
                    return fldObj;
                }

                var phone = fldObj.value;
                var phoneCode;
                var phoneSuffix = '';
                var phonePrefix = '';

                for (var i = 0; i < fldObj.phoneCodes.length; i++) {
                    if (fldObj.phoneCodes[i].iso === app.config.country) {
                        phoneCode = fldObj.phoneCodes[i].phoneCode;
                        break;
                    }
                }

                if (phoneCode && phone) { 
                    phoneSuffix = phone;
                    if (phoneSuffix.startsWith('+')) {
                        phoneSuffix = phoneSuffix.replace('+', '');
                    }
                    else if (phoneSuffix.startsWith('00')) {
                        phoneSuffix = phoneSuffix.replace('00', '');
                    }

                    if (phoneSuffix.startsWith(phoneCode)) {
                        phoneSuffix = phoneSuffix.replace(phoneCode, '');
                        phonePrefix = phoneCode;
                    }
                    else if (phone.startsWith('0')) {
                        phoneSuffix = phone.replace('0', '');
                        phonePrefix = phoneCode;
                    }
                    else {
                        phoneSuffix = phone;
                    }
                    fldObj.value = phonePrefix + '-' + phoneSuffix;
                }
                else if (phoneCode) {
                    phonePrefix = phoneCode;
                    fldObj.value = phonePrefix + '- ';
                }
            }

            return fldObj;
        },
        postRender: function($elm) {
            var $phoneSuffix = $elm.siblings('#composite_phone_suffix');
            if ($phoneSuffix.val() === ' ') {
                $phoneSuffix.val('');
            }
        },
        checks: {
            maxlength: {
                max: 15 + 1,
                msgKey: 'invalid_phone_number'
            },
            testCompositePhone: {
                msgKey: 'invalid_phone_number'
            },
            testRegex: {
                regex: /^[0-9]+\-[1-9][0-9]*$/, // do not allow "0" after the country code
                msgKey: 'invalid_phone_number'
            }
        }
    },
    bacs_withdraw_sort_code: {
        maxlength: 6,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            maxlength: {
                max: 6,
                msgKey: 'maxlength'
            },
            exactlength: {
                len: 6,
                msgKey: 'bacs_invalid_sort_code'
            }
        }
    },
    bacs_withdraw_account_number: {
        maxlength: 8,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            maxlength: {
                max: 8,
                msgKey: 'maxlength'
            },
            exactlength: {
                len: 8,
                msgKey: 'bacs_invalid_account_number'
            }
        }
    },
    bacs_withdraw_account_name: {
        maxlength: 18,
        checks: {
            minlength: {
                min: 1,
                msgKey: 'minlength'
            },
            maxlength: {
                max: 18,
                msgKey: 'maxlength'
            },
            testBacsWithdrawAccountName: {
                msgKey: 'bacs_invalid_account_name'
            }
        }
    },
    barter_email: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    barter_phone: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    barter_firstName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    barter_lastName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    bTransfer_email: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    bTransfer_phone: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    bTransfer_firstName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    bTransfer_lastName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    bTransfer_city: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    bTransfer_street: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    bTransfer_bankAccountNumber: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    co_accountType: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    co_accountBankCode: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    co_accountIdentificationType: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    co_accountNumber: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    co_accountIdentification: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    electronic_bank_transf_clabe_number: {
        maxlength: 18,
        checks: {
            exactlength: {
                len: 18,
                msgKey: 'exact_digits'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }

    },
    electronic_bank_transf_bank_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsAndLettersOnly: {
                msgKey: 'invalid_alphanumeric'
            }
        }
    },
    'pm-placeholder': {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            custom: {
                fn: function (value) {
                    return !!value && value !== "0";
                },
                msgKey: ''
            }
        }
    },
    cc_exp_year: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'select';
                fldObj.selectInvisible = app.config.useOneRowExpDate;
                fldObj.dropDownOptions = app.util.getYearsArr();
            }
            return fldObj;
        },
        postRender: function (element) {
            if (app.config.useOneRowExpDate) {
                app.util.oneRowExpDate('#exp_date', '.oneRowDate');
            } else if (element[0].tagName === 'SELECT') {
               element.cSelect(); // ensure some PT WD themes
            }
        },
        checks: {
            custom: {
                fn: function (shortYear) {
                    return app.util.isFutureDate(shortYear, $('.cc_exp_month').val());
                },
                msgKey: 'invalid_expiration_date'
            }
        }
    },
    cc_exp_month: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'select';
                fldObj.selectInvisible = app.config.useOneRowExpDate;
                fldObj.dropDownOptions = app.util.getMonthsArr();
            }
            return fldObj;
        },
        postRender: function (element) {
            if (app.config.useOneRowExpDate) {
                app.util.oneRowExpDate('#exp_date', '.oneRowDate');
            } else if (element[0].tagName === 'SELECT') {
                element.cSelect();// ensure some PT WD themes
            }
        },
        checks: {
            custom: {
                fn: function (month) {
                    // return isValidDate($('.cc_exp_year').val(), month);
                    return app.util.isFutureDate($('.cc_exp_year').val(), month);
                },
                msgKey: 'invalid_expiration_date'
            }
        }
    },
    cc_name_on_card: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 40,
                msgKey: 'maxlength'
            },
            validateCardHolderNameOnWD: {
                msgKey: 'invalid_cardholder_name'
            }
        }
    },
    cc_card_number: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.placeholder = app.util.getCardPlaceholder(fldObj);
            }
            return fldObj;
        },
        postRender: app.util.cardNumberPostRender,
        maxlength: 23,
        checks: {
            asyncCheck:{
                fn: function(v, p){return app.util.asyncCheck.getCardErrorMsg(v);},
                restricted_bothBrandsMsgKey: 'restricted_bothBrands'
                // /** add "msgKey"s to overwrite Srv Response Text **/
                // ,restricted_cardTypeMsgKey        : "restricted_card_type"
                // ,restricted_cardProductMsgKey     : "restricted_card_type"
                // ,restricted_issuerCountryMsgKey   : "restricted_card_issuer_country"
                // ,restricted_userCountryMsgKey     : "restricted_card_user_country"
            },
            cc_minlength: {
                min: 8,
                msgKey: 'invalid_creditcard'
            },
            cc_maxlength: {
                max: 19,
                msgKey: 'maxlength'
            },
            creditcard: { //valid_credit_card
                msgKey: 'invalid_creditcard'
            },
            isCardAcceptable: {
                msgKey: 'invalid_creditcard',
                restrictedCCMsgKey: 'restricted_card_type',
                restrictedCCCurrencyMsgKey: 'restricted_card_currency',
                allowedCCMsgKey: 'allowed_card_type',
                restrictedCCCountryMsg: 'card_country_not_allowed'
            },
            recognizedIssuer: {
                msgKey: 'invalid_creditcard'
            }
        }
    },
    cc_card_number_upo_ro : {
		checks : {
			isCurrencySupportedByTheCard: {
				restrictedCCCurrencyMsgKey    : 'restricted_card_currency'
			}
		}
	},
    cc_cvv2: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 4;
                fldObj.inputType = 'password'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
                fldObj.inputMode = 'decimal';
            }
            return fldObj;
        },
        postRender: function($element){
            $element.setMask('cvv');
        },
        checks: {
            testCVV2: {
                msgKey: 'exact_digits',
                unknownCCMsgKey: 'enter_cvv'
            }
        }
    },
    visa_checkout_cc_cvv2: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 4;
                fldObj.inputType = 'password'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
                fldObj.inputMode = 'decimal';
            }
            return fldObj;
        },
        postRender: function($element){
            $element.setMask('cvv');
        },
        checks: {
            testCVV2: {
                msgKey: 'exact_digits',
                unknownCCMsgKey: 'enter_cvv'
            }
        }
    },
    vfpIban: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBAN: {
                msgKey: 'invalid_iban'
            }
        }
    },
    vfpSortCode: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel';
            }

            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 6,
                msgKey: "exact_digits"
            }
        }
    },
    vfpAccountNumber: {
        checks: {
            notEmpty: {
              msgKey: 'required_field'
            }
        }
    },
    coindirect_crypto_address: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    coindirect_crypto_currency: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    efecty_personal_id: {
        checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
    },
    jpmorganBranchCode: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    jpmorganAccountNumber: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    jpmorganEnterpriseName: {
        renderMutator: function(fldObj) {
            fldObj.maxlength = 140;
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    jpmorganPersonalId: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    lpeIBAN: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBAN: {
                msgKey: 'invalid_iban'
            }
        }
    },
    lpeAccountNumber: {
        renderMutator: function(fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel';
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            testLPEAccountNumber: {
                msgKey: 'invalid_account_number'
            }
        }
    },
    lpeBankNumber: {
        renderMutator: function(fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel';
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            testLPEBankNumber: {
                msgKey: 'invalid_bank_number'
            }
        }
    },
	lean_name: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_city: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_address: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_country: {
        renderMutator: function (fldObj) {
            if (fldObj && fldObj.dropDownOptions) {
                if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                    var opt = app.util.findOptionByValue(fldObj.dropDownOptions, fldObj.value);
                    fldObj.value = (opt && opt.text || fldObj.value);
                } else {
                    fldObj.dropDownOptions = [{value: "", text: app.locale.please_select}].concat(fldObj.dropDownOptions);
                }
            }

            return fldObj;
        },
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
    lean_iban: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBAN: {
                msgKey: 'invalid_iban'
            }
        }
    },
    mazooma_fi_routing: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            exactlength: {
                len: 9,
                msgKey: 'exact_digits'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    mazooma_fi_account_number: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 17,
                msgKey: 'maxlength'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    mazoomaFiName: {
        renderMutator : function (fldObj) {
            if (fldObj && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                fldObj.value =
                    app._t("bank_name") + ": " +
                    fldObj.value;
            }
            return fldObj;
        }
    },
    mazoomaFiAcc: {
        renderMutator : function (fldObj) {
            var accountTypes = {
                "ps": "personal_savings",
                "pc": "personal_checking"
            };
            if (fldObj && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                fldObj.value =
                    app._t("mazooma_fi_account_type") + ": " +
                    app._t(accountTypes[fldObj.value.toLowerCase()] || fldObj.value);
            }
            return fldObj;
        }
    },
    mbMoney_email: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    mbMoney_phone: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    mbMoney_firstName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    mbMoney_lastName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    nequi_phone_number: {
        renderMutator: function(fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel';
            }
            return fldObj;
        },
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength: {
				len: 10,
				msgKey: 'exact_digits'
			}
		}
	},
    nettelerAccount: {
        maxlength: 254, // Yes, email can be that long!
        checks: {
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    nettelerSecureId: { // issue PPPWDR-427 (OR ??netellerSecureId ??)
        maxlength: 6,
        checks: {
            exactlength: {
                len: 6,
                msgKey: 'netteler_secure_id_validation'
            },
            digitsOnly: {
                msgKey: 'netteler_secure_id_validation'
            }
        }
    },
    neosurf_beneficiaryEmail: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    npp_account_number: {
        checks: {
            notEmpty  : {
				msgKey : 'required_field'
			},
            digitsOnly: {
                msgKey : 'digits_only'
            },
            minlength: {
                min: 3,
                msgKey: 'minlength'
            },
            maxlength: {
                max: 9,
                msgKey: 'maxlength'
            }
        }
    },
    npp_account_name: {
        renderMutator: function (fldObj) {
            fldObj.maxlength = 100;
            return fldObj;
        },
        checks: {
            notEmpty  : {
				msgKey : 'required_field'
			},
            minlength: {
                min: 2,
                msgKey: 'minlength'
            },
            maxlength: {
                max: 100,
                msgKey: 'maxlength'
            }
        }
    },
    npp_bankStateBranch_number: {
        checks: {
            notEmpty  : {
				msgKey : 'required_field'
			},
            exactlength: {
                len: 7,
                msgKey: 'exact_characters'
            },
            testRegex: {
                regex: /^\d{3}-\d{3}$/,
                msgKey: "invalid_field"
            }
        }
    },
    npp_pay_id: {
        renderMutator: function (fldObj) {
            fldObj.maxlength = 256;
            return fldObj;
        },
        checks: {
            notEmpty  : {
				msgKey : 'required_field'
			},
            validateNppPayId: {
                controlSelector: '#npp_pay_id_type',
                invalidEmailMsgKey : 'invalid_email'
            }
        }
    },
    npp_pay_id_type: {
        renderMutator: function (fldObj) {
            if (fldObj && fldObj.dropDownOptions) {
                if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                    var opt = app.util.findOptionByValue(fldObj.dropDownOptions, fldObj.value);
                    fldObj.value = (opt && opt.text || fldObj.value);
                    fldObj.inputType = 'text';
                } else {
                    fldObj.dropDownOptions = [{value: "", text: app.locale.please_select}].concat(fldObj.dropDownOptions);
                }
            }

            return fldObj;
        },
        postRender: function ($elm) {
            $elm.on("change", function () {
                $("#npp_pay_id").trigger("focusout");
            })
        },
        checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
        }
    },
    oktocash_terms: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'checkbox';
            }
            return fldObj;
        },
        checks: {
            isChecked: {
                selector: '#oktocash_terms',
                msgKey: 'unconfirmed_privacy_policy'
            }
        }
    },
    oktocash_termsOfUse: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'checkbox';
            }
            return fldObj;
        },
        checks: {
            isChecked: {
                selector: '#oktocash_termsOfUse',
                msgKey: 'unconfirmed_agreement'
            }
        }
    },
    oktowallet_email: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    oktowallet_terms: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'checkbox';
            }
            return fldObj;
        },
        checks: {
            isChecked: {
                selector: '#oktowallet_terms',
                msgKey: 'unconfirmed_agreement'
            }
        }
    },
    pay4funId : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
    pes_email : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
    pix_accountNum: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 100;
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            validatePixKey: {
                msgKey : 'required_field',
                invalidCpfMsgKey: 'exact_digits',
                digitsOnlyMsgKey: 'digits_only',
                invalidPhoneMsgKey: 'invalid_pix_phonenumber',
                invalidEmailMsgKey: 'invalid_email',
                invalidChaveMsgKey: 'maxlength',
            }
        }
    },
    pix_bankId: {
        renderMutator : function (fldObj) {
            if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                var opt = app.util.findOptionByValue(fldObj.dropDownOptions, fldObj.value);
                fldObj.value = app._t(opt && opt.text || fldObj.value);
                fldObj.inputType = 'text';
            }

            return fldObj;
        }
    },
    pix_personal_id: {
        checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
    },
    pix_key: {
        checks: {
            notEmpty  : {
				msgKey : 'required_field'
			},
            validatePixKey: {
                msgKey : 'required_field',
                invalidCpfMsgKey: 'exact_digits',
                digitsOnlyMsgKey: 'digits_only',
                invalidPhoneMsgKey: 'invalid_pix_phonenumber',
                invalidEmailMsgKey: 'invalid_email',
                invalidChaveMsgKey: 'maxlength',
            }
        }
    },
    pix_key_type: {
        postRender: function ($elm) {
            $elm.on("change", function () {
                $("#pix_key, #pix_accountNum").trigger("focusout");
            })
        }
    },
    pixCpf: {
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            digitsOnly: {
                msgKey : 'digits_only'
            },
            exactlength: {
                len: 11,
                msgKey: 'exact_digits'
            },
            testPersonalId : {
                msgKey : 'invalid_personal_id'
            }
        }
    },
    pixEmail: {
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    pixRandom: {
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            maxlength: {
                max   : 40,
                msgKey: 'maxlength'
            }
        }
    },
    pixPhone: {
        postRender: function () {
            $('#country_phone_code').trigger("change");
        },
        renderMutator : function (fldObj) {
            if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                fldObj.value = fldObj.value.replace(/-/g, '');
            } else {
                fldObj.inputType = 'composite_phone';
                fldObj.phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes, 'apmgw_PIX');

                if (fldObj.phoneCodes.length === 2 && !fldObj.phoneCodes[0].phoneCode) {
                    fldObj.phoneCodes.shift();
                }

                if (fldObj.value && fldObj.value.startsWith('55') && !fldObj.value.startsWith('55-')) {
                    fldObj.value = '55-' + fldObj.value.substring(2);
                }
            }

            return fldObj;
        },
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testCompositePhone  : {
                msgKey : 'invalid_phone_number'
            },
            exactlengthCompositePhoneWithoutCode: {
                len: 11,
                msgKey : 'exact_digits'
            }
        }
    },
    postFinanceIban: {
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testIBAN : {
                msgKey : 'invalid_iban'
            }
        }
    },
    swishPhone: {
        renderMutator : function (fldObj) {
            if (fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                fldObj.value = fldObj.value.replace(/-/g, '');
            }
            else {
                fldObj.inputType = 'composite_phone';
                fldObj.phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes, 'apmgw_Swish');

                if (fldObj.phoneCodes.length === 2 && !fldObj.phoneCodes[0].phoneCode) {
                    fldObj.phoneCodes.shift();
                }
            }

            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testRegex: {
                regex: /^46-[0-9]{8,10}$/,
                msgKey: 'invalid_phone_number'
            }
        }
    },
    polandInstantPayoutIban: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBAN: {
                msgKey: 'invalid_iban'
            }
        }
    },
    polandInstantPayoutNrb: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 26,
                msgKey: 'exact_digits'
            }
        }
    },
    tw_accountType: {
        renderMutator : function (fldObj) {
            if (fldObj && fldObj.dropDownOptions) {
                if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                    var opt = app.util.findOptionByValue(fldObj.dropDownOptions, fldObj.value);
                    fldObj.value = (opt && opt.text || fldObj.value);
                } else {
                    fldObj.inputType = 'select';
                }
            }
            return fldObj;
        },
    },
    wd_abaqoos_account_id: {
        maxlength: 20,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    wd_web_money_account_id: {
        maxlength: 254, // Max length not defined
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    wd_moneta_account_id: {
        maxlength: 8,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            exactlength: {
                len: 8,
                msgKey: 'exact_digits'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    moneta_account_id: {
        maxlength: 8,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            exactlength: {
                len: 8,
                msgKey: 'exact_digits'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    wd_moneta_payment_password: { // issue PPPWDR-427
        maxlength: 5,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            exactlength: {
                len: 5,
                msgKey: 'exact_digits'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            }
        }
    },
    wd_ewire_account_id: {
        maxlength: 254, // Max length not defined
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    qiwi_phonenumber: { // issue PPPWDR-427
        maxlength: 15,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testQiwiPhonenumber: {
                msgKey: 'invalid_qiwi_phonenumber'
            },
            maxlength: {
                max   : 15,
                msgKey: 'maxlength'
            }
        }
    },
    wd_mb_email: { // Skrill
        maxlength: 254, // Max length not defined
        checks: {
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    ids_account_id: { //// issue CASH-346 change wd_instadebit_account_id to ids_account_id
        maxlength: 30,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testInstadebitAccountId: {
                msgKey: 'invalid_instadebit_account_id'
            }
        }
    },
    expresscheckout_account_id: { //PAYPAL
        maxlength: 254, // Max length not defined
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    ecoPayz_account_id: { //ecoPayz
        maxlength: 10,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            inRange: {
                min: 1000000000,
                max: 2147483647,
                msgKey: 'not_in_range_account_id'
            }
        }
    },
    webanq_account_id: { // issue PPPWDR-427
        maxlength: 15,
        checks: {
            testWBAccountId: {
                msgKey: 'not_in_range_account_id'
            }
        }
    },
    webanq_account_password: { // issue PPPWDR-427
        maxlength: 32,
        checks: {
            testWBAccountPassword: {
                msgKey: 'invalid_password'
            }
        }
    },
    webanq_password: {
        maxlength: 32,
        checks: {
            testWBAccountPassword: {
                msgKey: 'invalid_password'
            }
        }
    },
    toditocash_card_number: { // issue PPPWDR-427
        maxlength: 10,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 10,
                msgKey: 'exact_digits'
            }
        }
    },
    toditocash_pin_code: { // issue PPPWDR-427
        maxlength: 10,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 10,
                msgKey: 'exact_digits'
            }
        }
    },
    tng_beneficiaryEmail: {
        renderMutator: function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'email';
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    tng_userName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    tng_beneficiaryMobileNumber: { 
        postRender: function () {
            $('#country_phone_code').trigger("change");
        },
        renderMutator : function (fldObj) {
            if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                fldObj.value = fldObj.value.replace(/-/g, '');
            } else {
                fldObj.inputType = 'composite_phone';
                fldObj.maxlength = 9;
                fldObj.phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes, 'apmgw_TouchnGo');

                if (fldObj.phoneCodes.length === 2 && !fldObj.phoneCodes[0].phoneCode) {
                    fldObj.phoneCodes.shift();
                }

                if (fldObj.value && fldObj.value.startsWith('60') && !fldObj.value.startsWith('60-')) {
                    fldObj.value = '60-' + fldObj.value.substring(2);
                }
            }

            return fldObj;
        },
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testCompositePhone  : {
                msgKey : 'invalid_phone_number'
            },
            exactlengthCompositePhoneWithoutCode: {
                len: 9,
                msgKey : 'exact_digits'
            }
        }
    },
    wd_pay_safe_first_name: { // issue PPPWDR-365
        maxlength: 40,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testPaySafeName: {
                msgKey: 'invalid_first_name'
            }
        }
    },
    wd_pay_safe_last_name: { // issue PPPWDR-365
        maxlength: 40,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testPaySafeName: {
                msgKey: 'invalid_last_name'
            }
        }
    },
    wd_pay_safe_birthdate: { // PaySafe // issue PPPWDR-365 (YYYY-MM-DD)
        maxlength: 40,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testPaySafeBirthdate: {
                msgKey: 'invalid_birthdate'
            },
            dateInThePast: {
                msgKey: 'invalid_birthdate'
            }
        }
    },
    wd_pay_safe_account_id: { // PaySafe // issue PPPWDR-365 email
        maxlength: 200,
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 200;
                fldObj.inputType = 'email'; // inputType = ['tel' |'password' | 'text' | 'number' | 'email'...]
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    citadel_holder_name: {     // PPPVFIVE-2245  /^.{1,50}$/
        maxlength: 50,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 50,
                msgKey: 'maxlength'
            }
        }
    },
    citadel_iban: {    // PPPVFIVE-2245  /^.{1,31}$/
        maxlength: 31,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 31,
                msgKey: 'maxlength'
            }
        }
    },
    citadel_swift_code: { // PPPVFIVE-2245 /^[A-Za-z]{6}[A-Za-z0-9]{2,5}$/
        maxlength: 11,
        checks: {
            testCitadelSwiftCode: {
                msgKey: 'invalid_swift_code'
            }
        }
    },
    citadel_bank_city: { // PPPVFIVE-2245 /^.{1,30}$/
        maxlength: 30,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 30,
                msgKey: 'maxlength'
            }
        }
    },
    citadel_bank_name: { // PPPVFIVE-2245 /^.{1,40}$/
        maxlength: 40,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 40,
                msgKey: 'maxlength'
            }
        }
    },
    citadel_account_numberCA: { // PPPVFIVE-2245 /^[0-9]{5,12}$/
        maxlength: 12,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            minlength: {
                min: 5,
                msgKey: 'minlength'
            },
            maxlength: {
                max: 12,
                msgKey: 'maxlength'
            }
        }
    },
    citadel_account_numberAU: { // PPPVFIVE-2245 /^[0-9]{5,9}$/
        maxlength: 9,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            minlength: {
                min: 5,
                msgKey: 'minlength'
            },
            maxlength: {
                max: 9,
                msgKey: 'maxlength'
            }
        }
    },
    citadel_branch_codeCA: { // PPPVFIVE-2245 /^[0-9]{5}$/
        maxlength: 5,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 5,
                msgKey: 'exact_digits'
            }
        }
    },
    citadel_bank_codeCA: { // PPPVFIVE-2245 /^[0-9]{3}$/
        maxlength: 3,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 3,
                msgKey: 'exact_digits'
            }
        }
    },
    citadel_branch_codeAU: { // PPPVFIVE-2245  /^[0-9]{6}$/
        maxlength: 6,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 6,
                msgKey: 'exact_digits'
            }
        }
    },
    citadel_ibanMX: { // PPPVFIVE-2245 /^[0-9]{18}$/
        maxlength: 18,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 18,
                msgKey: 'exact_digits'
            }
        }
    },
    fasterPayments_iban: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBAN: {
                msgKey: 'invalid_iban'
            }
        }
    },
    fasterPayments_sort_code: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'tel';
            }

            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 6,
                msgKey: "exact_digits"
            }
        }
    },
    fasterPayments_account_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    iDebit_account_id: { // CASH-374
        maxlength: 30,
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testInstadebitAccountId: {
                msgKey: 'invalid_idebit_account_id'
            },
            maxlength: {
                max: 30,
                msgKey: 'maxlength'
            }
        }
    },
    israeli_card_holder_id: { // BACKLOG-211
        maxlength: 30,
        checks: {
            digitsOnly: {
                msgKey: 'digits_only'
            },
            minlength: {
                min: 4,
                msgKey: 'minlength'
            },
            maxlength: {
                max: 9,
                msgKey: 'maxlength'
            },
            testIsraeliCardHolderID: {
                msgKey: 'invalid_israeli_card_holder_id'
            }
        }
    },
    wd_iban: {
        normalizeSubmittedVal: function(val){
            return val.toUpperCase().replace(/ /g, '');
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBANWithSpacesInsensitive: {
                msgKey: 'invalid_iban'
            }
        }
    },
    wd_iban_sepa_manual: {
        normalizeSubmittedVal: function(val){
            return val.toUpperCase().replace(/ /g, '');
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBANWithSpacesInsensitive: {
                msgKey: 'invalid_iban'
            },
        }
    },
    swissPayouts_iban: {
        normalizeSubmittedVal: function(val){
            return val.toUpperCase().replace(/ /g, '');
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBANWithSpacesInsensitive: {
                msgKey: 'invalid_iban'
            }
        }
    },
    swissPayouts_bic: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 11;
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testBic: {
                msgKey: 'invalid_bic_capital_letters'
            }
        }
    },
    wt_iban: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 21;
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            alphanumeric: {
                msgKey: 'invalid_iban'
            },
            exactlength : {
                len    : 21,
                msgKey : 'invalid_iban'
            }
        }
    },
    wt_bic: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 11;
            }
            return fldObj;
        }
        // checks: { // uncomment when field become required
        //     notEmpty: {
        //         msgKey: 'required_field'
        //     },
        //     testWTBic: {
        //         msgKey: 'invalid_bic'
        //     },
        //     exactlength : {
        //         len    : 11,
        //         msgKey : 'invalid_bic'
        //     }
        // }
    },
    astro_pay_prepaidBF_email_or_phone: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testAstroPayPhone: {
                msgKey: 'invalid_phone_number'
            }
        }
    },
    astropaycard_accountId: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "tel";
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testAstroPayPhone: {
                msgKey: 'invalid_phone_number'
            }
        }
    },
    wd_astro_pay_prepaidBF_document_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    wd_astro_pay_prepaidBF_beneficiary_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    wd_astro_pay_prepaid_account_id: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testAstroPayPhone: {
                msgKey: 'invalid_phone_number'
            }
        }
    },
    wd_astro_pay_prepaid_document_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    wd_astro_pay_prepaid_beneficiary_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    easy_eft_payouts_bank_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    easy_eft_payouts_account_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    muchBetter_mobilePhone         : {
        renderMutator : function (fldObj) {
            if (fldObj) {
                if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                    fldObj.value = fldObj.value.replace(/-/g, '');
                } else {
                    fldObj.phoneCodes = app.util.getMuchBetterPhoneCodes(app.phoneCodes); // app.util.getFilteredPhoneCodes(app.phoneCodes, 'apmgw_MuchBetter');
                    fldObj.maxlength = 15;
                    fldObj.inputType = 'composite_phone';
                }
            }
            return fldObj;
        },
        checks : {
            testCompositePhone  : {
                msgKey : 'invalid_phone_number'
            },
            maxlength : {
                max    : 18,
                msgKey : 'maxlength'
            }
        }
    },
    interac_answer : {
        checks : {
            notEmpty  : {
                msgKey : 'required_field'
            },
            minlength: {
                min    : 3,
                msgKey : 'minlength'
            },
            maxlength : {
                max    : 25,
                msgKey : 'maxlength'
            },
            testRegex: {
                regex: /^[^\s]([a-zA-Z0-9àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+)[^\s]$/,
                msgKey: 'invalid_field',
            }
        }
    },
    interac_email : {
        checks : {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    interac_eTransfer_email : {
        checks : {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    interac_eTransfer_mobilePhone: { // WD
        postRender: function($element){
            $element.setMask('phone_interac');
        },
        normalizeSubmittedVal: function(val){
            return val.replace(/-/g, '');
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testPhonenumber  : {
                msgKey : 'invalid_phonenumber'
            },
            minlength     : {
                min    : 12,
                msgKey : 'minlength'
            },
            maxlength: {
                max: 12, // 1234567890 | 123-456-7890
                msgKey: 'maxlength'
            }
        }
    },
    interac_Combined_email : {
        checks : {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    interac_Combined_mobilePhone: {
        postRender: function($element){
            $element.setMask('phone_interac');
        },
        normalizeSubmittedVal: function(val){
            return val.replace(/-/g, '');
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testPhonenumber  : {
                msgKey : 'invalid_phonenumber'
            },
            minlength     : {
                min    : 12,
                msgKey : 'minlength'
            },
            maxlength: {
                max: 12, // 1234567890 | 123-456-7890
                msgKey: 'maxlength'
            }
        }
    },
    interac_instant_email: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "email";
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    interac_instant_phone: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "tel";
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength : {
                len    : 10,
                msgKey : 'exact_digits'
            }
        }
    },
    interac_instant_security_answer: {
        postRender: function($element) {
            var msg = app.locale.interac_security_answer_hint;
            var $hint = $("<div>")
                .addClass("row interac_security_answer_hint")
                .html(msg);

            $element.closest(".row").after($hint);
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            minlength: {
                min: 6,
                msgKey: 'minlength'
            },
            maxlength : {
                max    : 25,
                msgKey : 'maxlength'
            },
            alphanumeric: {
                msgKey: 'invalid_alphanumeric'
            }
        }
    },
    expressConnect_institutionNumber: { // WD
        maxlength: 3,
        postRender: function($element){
            $element.numberMask({type : 'number', beforePoint : 5, afterPoint : 0})
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly  : {
                msgKey : 'digits_only'
            },
            maxlength : {
                max    : 3,
                msgKey : 'maxlength'
            }
        }
    },
    expressConnect_transitNumber: {     // WD
        maxlength: 5,
        postRender: function($element){
            $element.numberMask({type : 'number', beforePoint : 9, afterPoint : 0})
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly  : {
                msgKey : 'digits_only'
            },
            maxlength : {
                max    : 5,
                msgKey : 'maxlength'
            }
        }
    },
    expressConnect_accountNumber: {     // WD
        maxlength: 12,
        postRender: function($element){
            $element.numberMask({type : 'number', beforePoint : 12, afterPoint : 0})
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly  : {
                msgKey : 'digits_only'
            },
            minlength     : {
                min    : 7,
                msgKey : 'minlength'
            },
            maxlength : {
                max    : 12,
                msgKey : 'maxlength'
            }
        }
    },
    wd_bank_account_iban : {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testIBAN: {
                msgKey: 'invalid_iban'
            }
        }
    },
    wd_bank_account_holder_name : {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 101,
                msgKey : 'maxlength'
            }
        }
    },
    echeck_account_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            maxlength : {
                max    : 12,
                msgKey : 'exact_digits'
            }
        }
    },
    echeck_aba_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength : {
                len    : 8,
                msgKey : 'exact_digits'
            }
        }
    },
    echeck_ssn: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength : {
                len    : 4,
                msgKey : 'exact_digits'
            }
        }
    },
    echeck_account_type: {
        renderMutator : function (fldObj) {
            var opts = [{'value': 'PC', 'text': 'personal_checking'}, {'value': 'PS', 'text': 'personal_savings'}];
            if (fldObj) {
                if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                    var opt = app.util.findOptionByValue(opts, fldObj.value);
                    fldObj.value = (opt && opt.text || fldObj.value);
                } else {
                    fldObj.inputType = 'select';
                    fldObj.dropDownOptions = opts;
                }
            }
            return fldObj;
        },
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            }
        }
    },
    epay_email: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    epay_cin: {
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            maxlength : {
                max    : 10,
                msgKey : 'maxlength'
            }
        }
    },
    easypay_userName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    easypay_email: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEmail: {
                msgKey: 'invalid_email'
            }
        }
    },
    easypay_personal_id: {
        renderMutator: function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "tel";
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength : {
                len    : 10,
                msgKey : 'exact_digits'
            }
        }
    },
    easypay_id_type: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    easypay_id_num: {
        renderMutator: function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "tel";
            }
            return fldObj;
        },
        checks: {
            notEmpty  : {
				msgKey : 'required_field'
			},
            exactlength: {
                len: 9,
                msgKey: 'exact_digits'
            }
        }
    },
    easypay_id_date: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "date";
            }
            return fldObj;
        },
        postRender: function ($el) {
            $el.attr('max', new Date().toISOString().split("T")[0])
        },
        normalizeSubmittedVal: function (val) {
            var date = new Date(val);
            var day = zeroPad(date.getDate());
            var month = zeroPad(date.getMonth() + 1);
            var year = date.getFullYear();

            function zeroPad(val) {
                return val < 10 ? ("0" + val) : val;
            }
            
            return day + "." + month + "." + year;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            dateInThePast : {
                msgKey : 'invalid_date'
            }
        }
    },
    gcash_accountName: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength: {
                max: 64,
                msgKey: 'maxlength'
            }
        }
    },
    gcash_beneficiaryPhone: {
        renderMutator: function (fldObj) {
            if (fldObj) {
                fldObj.inputType = "tel";
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
				msgKey: 'required_field'
			},
            exactlength: {
                len: 11,
                msgKey: 'exact_digits'
            }
        }
    },
    p24_iban: {
        checks : {
            notEmpty : {
                msgKey : 'required_field'
            },
            testIBAN : {
                msgKey : 'invalid_iban'
            }
        }
    },
    pay4fun_account_email: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.inputType = 'email';
            }
            return fldObj;
        },
        checks: {
            nonEmpty: {
                msgKey: 'required_field'
            },
            testEmail : {
                msgKey : 'invalid_email'
            }
        }
    },
    payout2c2p_beneficiaryBankCode: {
        renderMutator : function (fldObj) {
            if (fldObj && fldObj.dropDownOptions) {
                if (fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                    var opt = app.util.findOptionByValue(fldObj.dropDownOptions, fldObj.value);
                    fldObj.value = (opt && opt.text || fldObj.value);
                } else {
                    fldObj.inputType = 'select';
                }
            }
            return fldObj;
        },
        normalizeSubmittedVal: function(val){
            var fldObj = app.currentMethodFields['payout2c2p_beneficiaryBankCode'];
            if (fldObj && fldObj.value && fldObj.visibilityMode === app.CONSTANTS.VISIBILITY_MODE.DISABLED) {
                return fldObj.value;
            }
            return val;
        },
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            maxlength : {
                max    : 10,
                msgKey : 'maxlength'
            }
        }
    },
    payout2c2p_beneficiaryAccountNo: {
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            maxlength : {
                max    : 30,
                msgKey : 'maxlength'
            }
        }
    },
    payout2c2p_beneficiaryName: {
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 150;
            }
            return fldObj;
        },
        checks: {
            notEmpty  : {
                msgKey : 'required_field'
            },
            testFullName : {
                msgKey : 'bacs_invalid_account_name'
            },
            maxlength : {
                max    : 150,
                msgKey : 'maxlength'
            }
        }
    },
    wiretransfer_account_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 50,
                msgKey : 'maxlength'
            }
        }
    },
    wiretransfer_iban: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 50,
                msgKey : 'maxlength'
            }
        }
    },
    wiretransfer_account_holder_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 50,
                msgKey : 'maxlength'
            }
        }
    },
    wiretransfer_address: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 50,
                msgKey : 'maxlength'
            }
        }
    },
    wiretransfer_bank_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 50,
                msgKey : 'maxlength'
            }
        }
    },
    wiretransfer_swift: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            maxlength : {
                max    : 50,
                msgKey : 'maxlength'
            }
        }
    },
    sightline_ssn: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly  : {
                msgKey : 'digits_only'
            },
            exactlength : {
                len    : 4,
                msgKey : 'exact_digits'
            }
        }
    },
    confirm_bankAccount: {
        checks : {
            notEmpty  : {
                msgKey : 'required_field'
            },
            custom: {
                fn: function (v, p) {
                    return v && v.trim() === $('#usr_bankAccount').val().trim();
                },
                msgKey : 'invalid_confirm_account'
            }
        }
    },
    manualwt_iban_or_account_number: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    manualwt_account_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    manualwt_address: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    manualwt_bank_name: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    manualwt_swift_routing_aba: {
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
        }
    },
    mazooma_dob: { // apmgw_eCheckSelect_DOB (YYYY-MM-DD)
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 10;
                fldObj.inputType = "date";
                fldObj.rowExtraClassName = "datePicker";
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testDateOfBirth : {
                msgKey : 'invalid_date_of_birth'
            }
        }
    },
    mazooma_state: { // apmgw_eCheckSelect_DOB
        renderMutator : function (fldObj) {
            if (fldObj) {
                fldObj.maxlength = 2;
            }
            return fldObj;
        },
        checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            testEcheckState: {
                msgKey: 'echeck_invalid_state'
            }
        }
    }
};
